export enum EAircraftStatus {
  Available = 'Available',
  Maintenance = 'Maintenance',
  OnTrip = 'OnTrip',
  NotAvailable = 'NotAvailable',
}
